import PublicLibraryVirtualProxy from './PublicLibraryVirtualProxy';

let oVirtualProxyLibrary = new PublicLibraryVirtualProxy();
oVirtualProxyLibrary.findBooks('test');
